import React from 'react';
import { Box, Typography } from '@mui/material';
import { LISTING_MODAL_SYNCED_BADGE_SX } from './listingModalGlassStyles';

const ListingModalSectionLabel = ({ children, badge = null }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.25, minWidth: 0 }}>
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        color: 'rgba(0,0,0,0.5)',
        fontWeight: 600,
        letterSpacing: 0.45,
        textTransform: 'uppercase',
        fontSize: '0.65rem',
      }}
    >
      {children}
    </Typography>
    {badge === 'synced' ? (
      <Box component="span" sx={LISTING_MODAL_SYNCED_BADGE_SX}>
        Synced
      </Box>
    ) : null}
  </Box>
);

export default ListingModalSectionLabel;
